module.exports = __webpack_public_path__ + "static/assets/319e96ceb7d466a5c2da8906c3f3b062.png";